import React from 'react';

import NamedRedirect from '../../components/NamedRedirect/NamedRedirect';

// Every missing route, deleted listing, deleted store, etc. renders this
// component (see Routes.js catch-all, ListingPageCarousel, StoreProfilePage,
// ListingPageCoverPhoto, InboxPage, CMSPage). Rather than showing a dead-end
// 404 page, it redirects to SearchPage with a flag SearchPage reads to show
// a small "no longer available" notice. NamedRedirect reads staticContext
// from React Router's own context (not a prop), so this works correctly no
// matter how deeply nested the component that rendered <NotFoundPage /> is -
// server/index.js's existing `context.url` handling turns it into a real
// HTTP redirect during SSR.
const NotFoundPage = () => <NamedRedirect name="SearchPage" search="?notice=unavailable" />;

export default NotFoundPage;
